export const GET_BRANCHES = 'GET_BRANCHES';
export const BRANCH_REQUEST = 'BRANCH_REQUEST';
export const CREATE_BRANCH = 'CREATE_BRANCH';
export const UPDATE_BRANCH = 'UPDATE_BRANCH';
export const DELETE_BRANCH = 'DELETE_BRANCH';
export const BRANCH_REQUEST_FAILURE = 'BRANCH_REQUEST_FAILURE';